import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Project from 'src/store/models/Project';
import Timer from 'src/store/models/Timer';
import Entry from 'src/store/models/Entry';
import EntrySuggestion from 'src/store/models/EntrySuggestion';
import moment from 'moment';
import EntityTags from 'src/components/Entries/EntityTags';
import EntityNotes from 'src/components/Entries/EntityNotes';
import EntryBillingIcon from 'src/components/Entries/BillingIcon';
export default {
  props: {
    type: {
      type: String,
      required: true
    },
    entity: {
      type: Object,
      required: true
    },
    showBulkActions: {
      type: Boolean,
      default: false
    },
    showAvatar: {
      type: Boolean,
      default: true
    },
    wrapperClass: {
      type: String,
      default: ''
    },
    onChange: {
      type: Function
    },
    parent: {
      type: Boolean,
      required: false
    },
    child: {
      type: Boolean,
      required: false
    }
  },
  components: {
    EntityTags: EntityTags,
    EntityNotes: EntityNotes,
    EntryBillingIcon: EntryBillingIcon
  },
  emits: ['changed', 'deleted', 'toggleChildren', 'update-entry', 'toggled'],
  data: function data() {
    return {
      hover: false,
      showActions: false
    };
  },
  computed: {
    isEntityLocked: function isEntityLocked() {
      return this.entity.locked;
    },
    canSeeBilling: function canSeeBilling() {
      return this.me.is_admin || Project.$isUserPM(this.entity.project.project_id, this.me.user_id);
    },
    entityEditable: function entityEditable() {
      return Entry.isEditable(this.entity, this.me) && (!this.entity.entryGroup || this.entity.entryGroup.length === 1);
    },
    isRunning: function isRunning() {
      return this.entity.timer_status === 'running';
    },
    entityMinutes: function entityMinutes() {
      if (this.type === 'entry') {
        return this.entity.entry_minutes;
      } else {
        if (this.type === 'suggestion') {
          return this.entity.entry_minutes;
        } else {
          var seconds = this.isRunning ? this.entity.seconds + moment.utc().diff(moment.utc(this.entity.timer_start), 'seconds') : this.entity.seconds;
          return parseInt(seconds / 60);
        }
      }
    },
    showNotes: function showNotes() {
      return this.entity.notes || this.entity.source && this.entity.source_text || this.entity.todo && this.me.account.hasFeature('project_management');
    },
    timeFrom: function timeFrom() {
      return moment(this.entity.time_from).format('HH:mm');
    },
    timeTo: function timeTo() {
      if (this.type === 'entry' || this.type === 'suggestion') {
        return moment(this.entity.time_to).format('HH:mm');
      }

      return null;
    },
    hasChildren: function hasChildren() {
      return this.entity.entryGroup && this.entity.entryGroup.length > 1;
    },
    isSelectable: function isSelectable() {
      var _this = this;

      if (this.hasChildren) {
        return this.entity.entryGroup.every(function (entry) {
          return Entry.isEditable(entry, _this.me);
        });
      }

      return this.entityEditable;
    }
  },
  methods: {
    onOpen: function onOpen() {
      var _this2 = this;

      if (this.type === 'suggestion') {
        this.openDialog('RegisterTimeDialog', {
          type: this.type,
          entity: this.entity,
          date: this.entity.entry_date,
          copy: true,
          onComplete: function onComplete() {
            _this2.$emit('changed');
          }
        });
      }
    },
    onUpdateTimerStatus: function onUpdateTimerStatus() {
      var _this3 = this;

      var timer = Timer.find(this.entity.timer_id);
      timer.$toggleStatus().then(function () {
        _this3.$q.notify({
          message: timer.timer_status === 'running' ? _this3.$t('components.entries.timer_paused') : _this3.$t('components.entries.timer_started'),
          type: 'positive'
        });
      }).catch(function () {});
    },
    onSaveTimerAsAnEntry: function onSaveTimerAsAnEntry() {
      var _this4 = this;

      var timer = Timer.find(this.entity.timer_id);
      timer.$saveAsAnEntry({}).then(function () {
        _this4.$q.notify({
          message: _this4.$t('timer.timer_saved_as_entry'),
          type: 'positive'
        });
      }).catch(function () {});
    },
    onEdit: function onEdit(event) {
      var _this5 = this;

      this.openDialog('RegisterTimeDialog', {
        type: this.type,
        entity: this.entity,
        onComplete: function onComplete(entity) {
          _this5.$emit('changed', entity);
        }
      });
    },
    onCopy: function onCopy(event) {
      this.openDialog('RegisterTimeDialog', {
        type: this.type,
        entity: this.entity,
        copy: true
      });
    },
    setBilled: function setBilled(billed) {
      var _this6 = this;

      var localEntry = this.entity;
      localEntry.billed = billed;
      this.$emit('changed', [localEntry]);
      Entry.api().update(this.entity.entry_id, _objectSpread(_objectSpread({}, this.entity), {}, {
        billed: billed
      })).then(function (result) {
        _this6.$emit('update-entry');
      }).catch(function (e) {
        console.log('err ', e);
      });
    },
    onDelete: function onDelete(event) {
      var _this7 = this;

      this.$emit('deleted', this.entity);

      if (this.type === 'entry') {
        Entry.api().destroy(this.entity.entry_id).then(function () {
          _this7.$q.notify({
            message: _this7.$t('general.deleted_entry'),
            type: 'positive'
          });
        }).catch(function () {});
      } else if (this.type === 'timer') {
        Timer.api().delete('/timers/' + this.entity.timer_id, {
          delete: this.entity.timer_id
        }).then(function () {
          _this7.$q.notify({
            message: _this7.$t('general.deleted_timer'),
            type: 'positive'
          });
        }).catch(function () {});
      } else if (this.type === 'suggestion') {
        EntrySuggestion.api().delete('/entry-suggestions/' + this.entity.entry_suggestion_id, {
          delete: this.entity.entry_suggestion_id
        }).then(function () {
          _this7.onChange();

          _this7.$q.notify({
            message: _this7.$t('general.deleted_suggestion'),
            type: 'positive'
          });
        }).catch(function () {});
      }
    },
    onLink: function onLink(event) {
      window.open(this.entity.source_url, 'blank');
    },
    costsAreVisible: function costsAreVisible(entity) {
      return this.type === 'entry' && entity.cost > 0 && this.me.is_owner;
    },
    revenuesAreVisible: function revenuesAreVisible(entity) {
      return this.type === 'entry' && entity.project.is_billable && this.me.is_admin;
    },
    showChildren: function showChildren() {
      if (this.entity.entryGroup && this.entity.entryGroup.length > 1) {
        this.$emit('toggleChildren');
      }
    }
  }
};